import { venuePersonaAvatarDataUri } from '../../public/venue-kiosk-avatars.js';

export function newPersonaSeed() {
  try {
    return crypto.randomUUID();
  } catch {
    return `persona-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  }
}

/** @param {string} [currentSeed] */
export function buildPersonaAvatarChoices(currentSeed) {
  const cur = String(currentSeed || newPersonaSeed());
  const out = [{ seed: cur, url: venuePersonaAvatarDataUri(cur) }];
  const seen = new Set([cur]);
  let guard = 0;
  while (out.length < 8 && guard < 400) {
    guard += 1;
    const s = newPersonaSeed();
    if (seen.has(s)) continue;
    seen.add(s);
    out.push({ seed: s, url: venuePersonaAvatarDataUri(s) });
  }
  return out;
}

export function personaAvatarUrl(seed) {
  return venuePersonaAvatarDataUri(String(seed || 'player'));
}
